/* Literally Aubsessed — Drug Lord Era theme
   Vanilla JS, no framework. Covers: product variant picking, quantity
   steppers (product + cart), accordions, product image thumbnails, and
   the <product-recommendations> custom element. */

document.documentElement.classList.remove('no-js');

/* ---------- Quantity steppers (generic) ---------- */
function bindStepper(decreaseEl, increaseEl, input) {
  if (!input) return;
  var min = parseInt(input.min || '0', 10);

  function setVal(v) {
    v = Math.max(min, v);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (decreaseEl) {
    decreaseEl.addEventListener('click', function () {
      setVal((parseInt(input.value, 10) || min) - 1);
    });
  }
  if (increaseEl) {
    increaseEl.addEventListener('click', function () {
      setVal((parseInt(input.value, 10) || min) + 1);
    });
  }
}

// Product page quantity
document.querySelectorAll('.qty-stepper').forEach(function (wrap) {
  // Skip cart item steppers here; handled separately below with their own ids.
  if (wrap.closest('.cart-item')) return;
  var input = wrap.querySelector('input[type="number"]');
  var dec = wrap.querySelector('[data-qty-decrease]');
  var inc = wrap.querySelector('[data-qty-increase]');
  bindStepper(dec, inc, input);
});

// Cart item quantity — changing the number input auto-submits the cart form
// (classic, no-AJAX pattern: reliable, works with Shopify's native /cart/update).
document.querySelectorAll('.cart-item .qty-stepper').forEach(function (wrap) {
  var input = wrap.querySelector('[data-cart-qty-input]');
  var dec = wrap.querySelector('[data-cart-qty-decrease]');
  var inc = wrap.querySelector('[data-cart-qty-increase]');
  input.min = '0';
  bindStepper(dec, inc, input);
  input.addEventListener('change', function () {
    var form = input.closest('form');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });
});

/* ---------- Accordion ---------- */
document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var row = btn.closest('.acc-row');
    var content = row.querySelector('.acc-content');
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    if (content) content.hidden = expanded;
  });
});

/* ---------- Product thumbnails ---------- */
document.querySelectorAll('.product-thumbs .thumb').forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var main = thumb.closest('.product-media').querySelector('.product-media-main img');
    var src = thumb.getAttribute('data-thumb-src');
    if (main && src) main.src = src;
  });
});

/* ---------- Product variant picker ---------- */
document.querySelectorAll('.product-form').forEach(function (form) {
  var section = form.closest('[id^="shopify-section-"]') || document;
  var variantsScript = form.querySelector('script[id^="ProductVariants-"]');
  if (!variantsScript) return;

  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (e) {
    return;
  }

  var variantIdInput = form.querySelector('[id^="ProductVariantId-"]');
  var priceEl = section.querySelector
    ? section.querySelector('[id^="ProductPrice-"]')
    : document.querySelector('[id^="ProductPrice-"]');
  var addBtn = form.querySelector('.add-to-cart');
  var addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;

  var optionGroups = form.querySelectorAll('.option-group');
  var selected = [];

  optionGroups.forEach(function (group) {
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    var selectedBtn = group.querySelector('.swatch.is-selected, .pill.is-selected');
    selected[idx] = selectedBtn ? selectedBtn.getAttribute('data-value') : null;
  });

  function formatMoney(cents) {
    // Falls back to a plain decimal if Shopify.formatMoney isn't loaded;
    // {{ shop.money_format }} styling is applied theme-wide via Liquid filters
    // everywhere except this live re-render, so adjust the symbol below if
    // your shop doesn't use USD.
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    return variants.find(function (v) {
      return (
        (v.option1 === null || v.option1 === selected[0]) &&
        (v.option2 === null || v.option2 === selected[1]) &&
        (v.option3 === null || v.option3 === selected[2])
      );
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="price-compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      html += formatMoney(variant.price);
      priceEl.innerHTML = html;
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addBtnText) {
        addBtnText.textContent = variant.available
          ? 'Add to Cart — ' + formatMoney(variant.price)
          : 'Sold Out';
      }
    }
  }

  form.querySelectorAll('.swatch, .pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.option-group');
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-value');

      group.querySelectorAll('.swatch, .pill').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      var labelEl = group.querySelector('[data-option-selected]');
      if (labelEl) labelEl.textContent = value;

      selected[idx] = value;
      updateUI();
    });
  });
});

/* ---------- Product recommendations ---------- */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    var url = this.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(
        function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('#product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          } else {
            this.innerHTML = '';
          }
        }.bind(this)
      )
      .catch(function () {
        /* Fail quietly — recommendations are a nice-to-have, not critical path. */
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
